module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921123834_T.e0bfafc1.jpg";